import { Button, Form, FormProps, Input, message, Select } from 'antd';
import { CompanyPropertyModalInputProp } from '..';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { externalUserApi } from '../../../../../services/api-external-user.services';
import { UpdateCompanyDto } from '../../../../../services/api-company-user.type';
import { ChangeCompanyPropertyBody, FetchCompanyProperty } from '../../../../../services/api-company-user.type';
import TextArea from 'antd/lib/input/TextArea';
import { isEmpty } from 'lodash';
import { ModalBase } from 'components/modal';
import styles from './company-property-modal.module.scss';
import { CommonButton } from 'components/common-button';
import { useInfiniteQuery, useQuery } from 'react-query';
import { PermissionEntity } from 'services/api-permission.type';
import { getCommonRegion } from 'services/api-permission.service';
import SelectSearch, { OptionsSelectType } from '../../../../../components/select-search/select-search';
import { useDebounce } from '../../../../../hooks/use-debounce';

type FieldType = {
  firmName: string;
  masID?: string;
  sfcID?: string;
  isin?: string;
  region?: string;
  firmDescription: string;
  typeList?: string[];
  parentCompanyId?: string;
  isin_alt?: string;
  diginex_company_name?: string;
};

const CompanyPropertyModal = (props: CompanyPropertyModalInputProp) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [isSubmitDisable, setIsSubmitDisable] = useState(true);
  const [companyData, setCompanyData] = useState<FieldType>({} as FieldType);

  const [form] = Form.useForm();
  const firmName = Form.useWatch('firmName', form) || '';
  const masID = Form.useWatch('masID', form) || '';
  const sfcID = Form.useWatch('sfcID', form) || '';
  const isin = Form.useWatch('isin', form) || '';
  const diginex_company_name = Form.useWatch('diginex_company_name', form) || '';
  const isin_alt = Form.useWatch('isin_alt', form) || '';
  const region = Form.useWatch('region', form) || '';
  const typeList = Form.useWatch('typeList', form) || '';
  const firmDescription = Form.useWatch('firmDescription', form) || '';
  const parentCompanyId = Form.useWatch('parentCompanyId', form) || '';
  const [companyName, setCompanyName] = useState<string>('');
  const [companyDisplayName, setCompanyDisplayName] = useState<string>('');
  const debounceValueCompanySearch = useDebounce<string>(companyName);
  // const [companyDetails, setCompanyDetails] = useState({ id: '' });
  const [companySelected, setCompanySelected] = useState<any>();


  useEffect(() => {
    const fetchCompanyPropertyData = async () => {
      const companyID = props.companyData?.id;
      let response: FetchCompanyProperty = {} as FetchCompanyProperty;
      if (companyID) {
        response = await externalUserApi.getCompanyProperty(+companyID);
        form.setFieldsValue({
          firmName: response?.data?.firm_name || '',
          masID: response?.data?.mas_id || '',
          sfcID: response?.data?.sfc_id || '',
          isin: response?.data?.isin || '',
          isin_alt: response?.data?.isin_alt || '',
          diginex_company_name: response?.data?.diginex_company_name || '',
          region: response?.data?.region || '',
          firmDescription: response?.data?.description || '',
          // typeList: response?.data?.type_list == '' || response?.data?.type_list == null ? [] : response?.data?.type_list.split(';'),
          parentCompanyId: response?.data?.parent_company.name,
          parentCompanyName: response?.data?.parent_company.name,
        });
        setCompanyName(response?.data?.parent_company.name);
        setCompanyDisplayName(response?.data?.parent_company.name);
      }


      setCompanyData({
        firmName: response?.data?.firm_name || '',
        masID: response?.data?.mas_id || '',
        sfcID: response?.data?.sfc_id || '',
        isin: response?.data?.isin || '',
        isin_alt: response?.data?.isin_alt || '',
        diginex_company_name: response?.data?.diginex_company_name || '',
        region: response?.data?.region || '',
        firmDescription: response?.data?.description || '',
        parentCompanyId: response?.data.parent_company_id || '',
      });

      setCompanySelected({ value: response?.data?.parent_company.id, label: response?.data?.parent_company.name });

    };
    fetchCompanyPropertyData();
  }, [props.companyData?.id, form]);

  useEffect(() => {
    if (Object.keys(companyData).length !== 0) {
      const companyFormDataIsChanged =
        companyData.firmName !== firmName ||
        companyData.masID !== masID ||
        companyData.sfcID !== sfcID ||
        companyData.isin !== isin ||
        companyData.region !== region ||
        companyData.firmDescription !== firmDescription ||
        //  companyData.typeList !== typeList ||
        companyData.parentCompanyId !== parentCompanyId ||
        companyData.diginex_company_name !== diginex_company_name ||
        companyData.isin_alt !== isin_alt;

      const requiredCompanyFormDataFieldIsValid = !isEmpty(firmName); // && !isEmpty(firmDescription);

      if (companyFormDataIsChanged && requiredCompanyFormDataFieldIsValid) {
        setIsSubmitDisable(false);
      } else {
        setIsSubmitDisable(true);
      }
    }
  }, [
    firmName,
    masID,
    sfcID,
    isin,
    isin_alt,
    diginex_company_name,
    region,
    firmDescription,
    typeList,
    companyData,
    parentCompanyId,
    companyData.firmName,
    companyData.masID,
    companyData.sfcID,
    companyData.isin,
    companyData.isin_alt,
    companyData.diginex_company_name,
    companyData.region,
    companyData.firmDescription,
    companyData.parentCompanyId,
    // companyData.typeList,
  ]);

  // load all region
  const { data: listAllRegion, isLoading: isRegionLoading } = useQuery(['getAllRegion'],
    async () => {
      let ret: PermissionEntity[] = [];

      ret = await getCommonRegion();
      ret.sort((a, b) => {
        return (a.display_name || '') > (b.display_name || '') ? 1 : -1;
      });
      return ret;
    },
    { staleTime: Infinity },
  );

  /*  const { data: listAllCompany, isLoading: isCompanyLoading } = useQuery(['listCompanyData'],
        async () => {
          let ret = await externalUserApi.getListCompany({});
          /!*ret.data.page.sort((a, b) => {
            return (a.data.display_name || '') > (b.display_name || '') ? 1 : -1;
          });*!/
          return ret.data.data;
        },
        { staleTime: Infinity },
    );*/

  const handleCancel = () => {
    props.setModalVisible?.(false);
  };

  const onFinish: FormProps<FieldType>['onFinish'] = async (values: FieldType) => {
    const companyID = props.companyData?.id || -1;
    const payload: ChangeCompanyPropertyBody = {
      firm_name: values.firmName,
      mas_id: values.masID,
      sfc_id: values.sfcID,
      isin: values.isin,
      region: values.region || '',
      description: values.firmDescription,
      //  type_list:values.typeList == null || values.typeList.length <=0 ? '' : values.typeList.join(';'),
      isin_alt: values.isin_alt,
      diginex_company_name: values.diginex_company_name,
    };
    let resp = await externalUserApi.changeCompanyProperty(+companyID, payload);

    const companyInfo: UpdateCompanyDto = {
      parent_company_id: companySelected?.value,
    };

    let resp1 = await externalUserApi.setParentCompany(+companyID, companyInfo);

    setModalOpen(false);
    props.setModalVisible?.(false);


    if (resp?.data?.success) {
      if (!resp1?.data?.success) {
        message.error(resp1?.data?.message);
      } else {
        message.success('update success');
      }

    }
    else {
      message.error('update fail');
    }
  };

  let fullCompanyTitle = props.companyData?.name || '';
  let shortCompanyTitle = (fullCompanyTitle.length > 20) ? (fullCompanyTitle.slice(0, 20) + '...') : fullCompanyTitle;


  const PAGE_SIZE = 7;

  const fetchListCompany = useCallback(
    ({ pageParam = 1 }) => {
      return externalUserApi.getOnlyListCompany({
        page: pageParam,
        pageSize: PAGE_SIZE,
        search: debounceValueCompanySearch,
      });
    },
    [debounceValueCompanySearch],
  );

  const onChangeCompanyInputSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 255) return;
    setCompanyName(e.target.value);
  };

  const {
    data: listCompanyData,
    isLoading: isListCompanyLoading,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery(['listCompanyData', debounceValueCompanySearch], fetchListCompany, {
    keepPreviousData: true,
    getNextPageParam: (lastPage) => {
      if (lastPage.data.page < lastPage.data.totalPage) return lastPage.data.page + 1;
      return undefined;
    },
  });

  const optionsListCompany = useMemo(() => {
    const result: OptionsSelectType[] = [];
    if (!listCompanyData) return [];

    listCompanyData.pages.forEach((page) => {
      page.data.data.forEach(({ id, name }) => {
        result.push({ id, name });
      });
    });
    //
    return result;
  }, [listCompanyData]);


  const handleScrollToBottom = useCallback(
    (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
      //debugger;
      const target = e.target as HTMLElement;
      const isAtBottom = Math.abs(target.scrollHeight - (target.scrollTop + target.clientHeight)) <= 1;
      if (!isAtBottom || !hasNextPage) return;

      fetchNextPage();
    },
    [fetchNextPage, hasNextPage],
  );

  const onCompanyDropdownVisibleChange = () => {
    //setCompanyName('');
    fetchListCompany({ pageParam: 1 });
  };


  const onCompanySelect = (idCompany: string) => {
    // setCompanyDetails({ id: idCompany });
    setCompanyDisplayName(optionsListCompany.find((v) => v.id === idCompany)?.name || '');
  };

  const onCompanyClear = () => {
    // setCompanyDetails({ id: '' });
    //setCompanyDisplayName('');
    setCompanyName('');
  };

  return (
    <div>
      <ModalBase
        open={modalOpen}
        title={<>Company Property - <span title={fullCompanyTitle}>{shortCompanyTitle}</span></>}
        onCancel={handleCancel}
        className={styles.companyPropertyModal}
        width={500}
      >
        <Form
          form={form}
          name="company-property-form"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          style={{ maxWidth: 500, width: '100%' }}
          initialValues={{
            remember: true,
            firmName: companyData.firmName,
            masID: companyData.masID,
            sfcID: companyData.sfcID,
            isin: companyData.isin,
            region: companyData.region,
            firmDescription: companyData.firmDescription,
            parentCompanyId: companyData.parentCompanyId,
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item<FieldType> label="Parent Company"
            name="parentCompanyId" rules={[]}>
            <SelectSearch
              optionsSelect={optionsListCompany}
              loading={isListCompanyLoading}
              onPopupScroll={handleScrollToBottom}
              onDropdownVisibleChange={onCompanyDropdownVisibleChange}
              onSelect={onCompanySelect}
              onClear={onCompanyClear}
              inputSearchProps={{
                value: companyName,
                onChange: onChangeCompanyInputSearch,
              }}
              placeholder="Search by Parent Company"
              defaultValue={companyDisplayName}
              value={companyDisplayName}
            />
          </Form.Item>
          {/*<Form.Item<FieldType>  label="Parent Company"
                                 name="parentCompanyId" rules={[]}>
            <Select
                showSearch
                allowClear
                placeholder="Company"
                onChange={(value,option)=>{
                  const aa = listAllCompany?.find(item=> item.id === value);
                  const bb = {value:aa?.id,label:aa?.name};
                  setCompanySelected(bb || {});
                }}
                loading={isCompanyLoading}
                options={listAllCompany?.map((company) => ({ value: company.id, label: company.name }))}
                virtual={false}     //scroll bug?
            />
          </Form.Item>*/}
          <Form.Item<FieldType>
            label={<>
              Firm Name
              <Button
                type="link"
                size='small'
                onClick={() => {
                  form.setFieldsValue({
                    firmName: props.companyData?.name,
                  });
                }}
                style={{ marginLeft: '200px', paddingBottom: 0, height: 'auto' }}
                title='Fill with company name'
              >
                company name
              </Button>
            </>}
            name="firmName"
            rules={[{ required: true, message: 'Firm name cannot be empty.' }]}
          >
            <Input showCount maxLength={255} placeholder="Firm Name" />
          </Form.Item>
          <Form.Item<FieldType> label="MAS ID" name="masID" rules={[]}>
            <Input showCount maxLength={255} placeholder="MAS ID" />
          </Form.Item>
          <Form.Item<FieldType> label="SFC ID" name="sfcID" rules={[]}>
            <Input showCount maxLength={255} placeholder="SFC ID" />
          </Form.Item>
          <Form.Item<FieldType> label={<span title='ISIN for a listed company'>ISIN</span>} name="isin" rules={[]}>
            <Input showCount maxLength={15} placeholder="ISIN" />
          </Form.Item>
          <Form.Item<FieldType> label="Region" name="region" rules={[]}>
            <Select
              showSearch
              allowClear
              placeholder="Region"
              loading={isRegionLoading}
              options={listAllRegion?.map((region) => ({ value: region.display_name, label: region.display_name }))}
              virtual={false}     //scroll bug?
            />
          </Form.Item>
          <Form.Item<FieldType>
            label={<span title='Provide a company name in Diginex system if it is not same as the company name'>Diginex Company Name</span>}
            name="diginex_company_name" rules={[]}>
            <Input showCount maxLength={255} placeholder="Diginex Company Name" />
          </Form.Item>
          <Form.Item<FieldType>
            label={<span title='ISIN for a listed company, or a self-defined code for a non-listed company'>ISIN/Alt</span>}
            name="isin_alt" rules={[]}>
            <Input showCount maxLength={15} placeholder="ISIN/Alt" />
          </Form.Item>
          <Form.Item<FieldType>
            label="Firm Description"
            name="firmDescription"
          // rules={[{ required: true, message: 'Firm description cannot be empty.' }]}
          >
            <TextArea showCount maxLength={5000} placeholder="Firm Description" rows={4} />
          </Form.Item>

          <div className={styles.alignButton}>
            <CommonButton onClick={handleCancel} variant="default" idKey='company-property-cancel'>
              Cancel
            </CommonButton>
            <Form.Item shouldUpdate className={styles.editItemButton}>
              {() => {
                return (
                  <CommonButton
                    htmlType="submit"
                    block
                    size="large"
                    variant="primary"
                    disabled={isSubmitDisable}
                    idKey='company-property-save'
                  >
                    Save
                  </CommonButton>
                );
              }
              }
            </Form.Item>
          </div>
        </Form>
      </ModalBase>
    </div>
  );
};

export default CompanyPropertyModal;
